// custom typefaces

// import "typeface-montserrat"
// import "typeface-merriweather"

// import "prismjs/themes/prism.css"
import "./codeTheme.css"
import wrapWithProvider from "./wrap-with-provider"

export const wrapRootElement = wrapWithProvider
